export const AUTH_CONSTANTS = {
  OTP_LENGTH: 6,
  RESEND_COOLDOWN_SECONDS: 60,
  DEFAULT_REDIRECT_PATH: "/admin/overview",
} as const;

export const AUTH_VALIDATION = {
  EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  OTP_PATTERN: /^\d{6}$/,
} as const;
